/**
 * Creates a image with score text in the middle
 * @param image
 * @param score
 */
function CreateScoreImage(backgroundImage, score)
{
    const width = 986;
    const height = 587;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const canvasCtx = canvas.getContext('2d');
    canvasCtx.drawImage(backgroundImage, 0, 0);
    canvasCtx.font = '150px Permanent Marker';
    canvasCtx.textAlign = 'center';
    canvasCtx.fillText(score, width / 2, (height / 2) + 150);

    canvasCtx.strokeStyle = '#FFFFFF';
    canvasCtx.lineWidth = 2;
    canvasCtx.strokeText(score, width / 2, (height / 2) + 150);

    return canvas.toDataURL();
}

export default CreateScoreImage;